export default {"src":"/_next/static/media/icon-pockie.cbc65c83.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};